import * as React from 'react';
import './LogIn.css';
import { RouteComponentProps, withRouter } from 'react-router';

interface IProps extends RouteComponentProps<any> {
    OnClick?: () => void;
}

const Footer = (props: IProps) => {

    const OnPolicyClick = () => {
        props.history.push("/policy");
    }

    const OnStatuteClick = () => {
		let win = window.open("/docs/regulamin_logowania_SSO.pdf", '_blank');
		if (win !== null)
		{
			win.focus();	
		}
    }

    return (
        <div className="footer">
            <div className="copyright-info">
                Copyright © 2020 Krajowa Izba Fizjoterapeutów
                        </div>
            <div className="policy-navigation">
                {/* <span
                    onClick={OnClick}
                    className="policy-navigation__item">
                    Bezpieczeństwo danych
                </span> */}
                <span
                    onClick={OnStatuteClick}
                    className="policy-navigation__item">
                    Regulamin
                </span>
                <span
                    onClick={OnPolicyClick}
                    className="policy-navigation__item">
                    Polityka prywatności
                </span>
            </div>
        </div>
    )
}

export default withRouter(Footer)


// WEBPACK FOOTER //
// ./src/components/Login/Footer.tsx